export default __webpack_public_path__ + "static/media/Talent_CorpseEater.4fa03192.png";